module.exports = __webpack_public_path__ + "static/ax-431800f008088505bc935913bf000688.png";